import React, { useState, useEffect } from "react";
import { Segment, Header } from "semantic-ui-react";

import axios from "axios";

import PostDownload from "./PostDownload";
import PostOptions from "./PostOptions";
import PostPreview from "./PostPreview";
import "./index.scss";

export default function SocialMediaPostBuilder() {
  const [postType, setPostType] = useState(1);
  const [postMessage, setPostMessage] = useState(1);
  const [postImg, setPostImg] = useState(2);
  const [dealerName, setDealerName] = useState("");

  useEffect(() => {
    axios.get(`/profile/`).then(({ data }) => {
      setDealerName(data.name);
    });
  }, []);

  return (
    <Segment padded>
      <Header
        content="Social Media Post Builder"
        subheader="Curate social media content"
      />
      <div className="post-wrapper">
        <div className="left">
          <PostOptions
            postType={postType}
            onPostTypeChange={(e) => setPostType(e)}
            postMessage={postMessage}
            onPostMessageChange={(e) => setPostMessage(e)}
            postImg={postImg}
            setPostImg={(e) => setPostImg(e)}
          />
          <PostDownload
            postType={postType}
            postImg={postImg}
            postMessage={postMessage}
          />
        </div>
        <PostPreview
          postMessage={postMessage}
          postType={postType}
          postImg={postImg}
          dealerName={dealerName}
        />
      </div>
    </Segment>
  );
}
